import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { Table } from "primeng/table";
import { ActivatedRoute, Router } from "@angular/router";
import { Dropdown } from "primeng/dropdown";
import { environment } from "src/environments/environment";
import { TournamentsService } from "src/app/services/tournamnet.service";
import * as moment from "moment";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfirmationService, MessageService } from "primeng/api";

@Component({
  templateUrl: "./income.component.html",
  styleUrls: ["./income.component.scss"],
  styles: [
    `
      :host ::ng-deep .p-datatable-gridlines p-progressBar {
        width: 100%;
      }
      @media screen and (max-width: 960px) {
        :host
          ::ng-deep
          .p-datatable.p-datatable-customers.rowexpand-table
          .p-datatable-tbody
          > tr
          > td:nth-child(6) {
          display: flex;
        }
      }
    `,
  ],
  providers: [MessageService, ConfirmationService],
})

export class AcademyTournamentIncomeListComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public showError: boolean = false;
  categoryList: any[] = [];
  mode;
  matchtypefilter;
  agegroupfilter;
  selectedGroupId;
  ageGroupList;
  playerdata;
  tournamentData;
  startDate;
  endDate;

  public courtTypeList = environment.courtTypeList;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  selectedAgeGroupId: any;
  playerRegister: boolean = true;
  errorMessage: any;
  academyId;
  selectedStartDateRange: Date[];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private tournamentsService: TournamentsService
  ) {}
  ngOnInit(): void {
    this.academyId = this.route.snapshot.paramMap.get("academyId");
    this.tournamentIncomeHistory();
  }
  onSelectCategory(event, id) {
    this.selectedGroupId = event.value.matchTypeId;
    let query = "getAgeGroup=true&matchtype=" + event.value.matchTypeId;
    this.tournamentsService.getTournamentCategory(id, query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        if (data) {
          this.ageGroupList = data.items;
        }
      },
      (err) => {}
    );
  }
  onAgeGroupSelect(event, tournamentId) {
    this.selectedAgeGroupId = event.value.ageGroupId;
    this.getPlayerList(tournamentId);
  }
  getPlayerList(id) {
    this.playerdata = [];
    let query =
      "?matchTypeId=" +
      this.selectedGroupId +
      "&ageGroupId=" +
      this.selectedAgeGroupId;

    this.tournamentsService.getListOfPlayers(id, query).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.playerdata = data.data.items;
      if (this.playerdata.length < 1) {
        this.playerRegister = false;
      } else {
        this.playerRegister = true;
      }
    });
  }

  async getTournamentCategory(id) {
    this.playerdata = [];
    this.playerRegister = true;
    let query = "getMatchtype=true";
    this.tournamentsService.getTournamentCategory(id, query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        if (data) {
          this.categoryList = data.items;
        }
      },
      (err) => {}
    );
  }
  tournamentIncomeHistory() {
    let query = "filterByDisable=false";
    let params = "";
    let first;
    let second;
    if (this.startDate != undefined && this.endDate != undefined) {
      first =moment(this.startDate).format("YYYY-MM-DD");
      second = moment(this.endDate).format("YYYY-MM-DD");
      this.selectedStartDateRange = [first, second];
 
    }
    if (this.selectedStartDateRange != null) {
        query += "&filterByStartDateRange=" + this.selectedStartDateRange;
      }
 
    this.tournamentsService
      .tournamentIncomeHistory(this.academyId, query)
      .subscribe(
        (data) => {
          console.log(this.academyId);
          this.tournamentData = data.items;
          data.items.forEach((element) => {
            let tmp = this.courtTypeList.find(
              (o) => o.value === element.courttype
            );

            if (tmp != undefined) {
              element.court = tmp.label;
            } else {
              element.court = "";
            }
          });
        },
        (err) => {
          this.errorMessage = err.error.message;
        }
      );
  }
  clear() {
    this.startDate = null;
    this.endDate = null;
    this.selectedStartDateRange=[];
    this.tournamentIncomeHistory();

}
onClickBack() {
    this.router.navigate(['manage/academies']);
}

ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
